var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.347,
    height: 16.618,
    viewBox: "0 0 9.347 16.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-wine-glass-alt",
    "data-name": "Icon awesome-wine-glass-alt",
    d: "M7.011,15.06h-1.3v-3.8a4.7,4.7,0,0,0,3.616-5L8.81.472A.515.515,0,0,0,8.3,0H1.047a.515.515,0,0,0-.51.472L.02,6.253a4.7,4.7,0,0,0,3.616,5v3.8h-1.3a1.3,1.3,0,0,0-1.3,1.3.26.26,0,0,0,.26.26H8.049a.26.26,0,0,0,.26-.26A1.3,1.3,0,0,0,7.011,15.06ZM2,1.558H7.343l.233,2.6h-5.8Z",
    transform: "translate(0)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasting);
export default __webpack_public_path__ + "static/media/tasting.b2e6228363d356139c84c0d1673797a1.svg";
export { ForwardRef as ReactComponent };